/**
 * @ngdoc directive
 * @name WebCoreModule.directive:ngRequired
 * @restrict A
 * @element input|select|textarea
 * @description
 * The ngRequired directive adds behavior to Angular's ngRequired attribute. With this directive in use, any tag with a
 * ng-required attribute will have a required field indicator added to the label for the field. The directive will also
 * add an appropriate legend to the form of the field, indicating what the required field indicator means.
 */

angular.module('WebCoreModule')
    .directive('ngRequired', ['WcTranslateConfiguratorService', '$compile', '$timeout', function (WcTranslateConfiguratorService, $compile, $timeout) {
        return {
            restrict: 'A',
            require: ['ngRequired', '^form'],
            scope: {
                ngRequired: '='
            },
            controller: ['$scope', '$element', '$attrs', function ($scope, $element, $attrs) { // jshint ignore:line
                // Look for the label to insert the required abbreviation
                this.insertionPoint = $('label[for="' + $attrs.id + '"]');
                // If it's a radio or checkbox, try to find legend for fieldset instead
                if ($element[0].type === 'checkbox' || $element[0].type === 'radio') {
                    this.insertionPoint = $element.closest('fieldset').find('legend');
                }

                // Look for the parent form to insert the required legend
                this.formElem = this.insertionPoint.closest('form');

                var getFormControls = function (formController) {
                    var formControls = [];

                    angular.forEach(formController, function (value) { // jshint ignore:line
                        if (typeof value === 'object' && value.hasOwnProperty('$valid')) {
                            this.push(value);
                        }
                    }, formControls);

                    return formControls;
                };

                this.calculateNumRequiredFields = function (formController) {
                    var formControls = getFormControls(formController);

                    var numRequiredFields = 0;
                    angular.forEach(formControls, function (value) { // jshint ignore:line
                        if (value.$error.required) {
                            numRequiredFields++;
                        }
                    });

                    return numRequiredFields;
                };


                this.addLabels = function (scope, attrs) { // jshint ignore:line

                    WcTranslateConfiguratorService.loadPartAndRefresh('WC-required');
                    $timeout(angular.bind(this, function () {
                        // check to make sure abbr is not already there before adding
                        if (this.insertionPoint.has('abbr[title="Required"]').length === 0 && !attrs.disabled && !attrs.readonly) {
                            this.insertionPoint.prepend('<abbr class="required h6" title="Required">*</abbr>');
                        }

                        //lastly, check for the form legend and add it if necessary
                        if (this.formElem.has('div.required-legend').length === 0 && !attrs.disabled && !attrs.readonly) {
                            this.formElem.prepend($compile('<div class="required-legend hidden-xs"><span class="required-text"><abbr class="required h6" title="Required">*</abbr> {{"required.requiredText" | translate}}</span></div>')(scope));
                        }
                    }), 0);
                };

                this.removeLabels = function (formController) {
                    this.insertionPoint.find('abbr.required').remove();
                    var numRequiredFields = this.calculateNumRequiredFields(formController);
                    if (numRequiredFields === 0) {
                        this.formElem.find('div.required-legend').remove();
                    }
                };
            }],

            link: function (scope, elem, attrs, ctrls) { // jshint ignore:line
                var ngRequiredController = ctrls[0];
                var formController = ctrls[1];

                scope.$watch(function () {
                    return scope.ngRequired;
                }, function (newValue) {
                    if (newValue) {
                        ngRequiredController.addLabels(scope, attrs);
                    } else {
                        ngRequiredController.removeLabels(formController);
                    }
                });
            }
        };
    }]);
